<template>
    <loading v-if="loading"></loading>
    <div v-else>
        <b-button variant="outline" @click="fetchPendingItems" v-if="showingRejectedItems">
            Back to Pending Items
        </b-button>
        <b-button variant="outline" @click="fetchRejectedItems" v-else>
            View Rejected Items
        </b-button>

        <b-table striped hover :items="items" :fields="fields" class="mt-3" v-if="items.length">
            <template #cell(type)="row">
                <span>{{ row.item.type }}</span>
            </template>
            <template #cell(titleOrContent)="row">
                <div v-if="row.item.type === 'post'">
                    <strong>{{ row.item.title }}</strong> <br>{{ row.item.description }}
                </div>
                <span v-else>{{ row.item.comment }}</span>
                <a class="d-block" v-if="row.item.url" :href="row.item.url">Open</a>
            </template>
            <template #cell(author)="row">
                <a v-if="row.item.author" :href="row.item.author.profile_url">{{ row.item.author.name }}</a>
                <span v-else>Anonymous</span>
            </template>
            <template #cell(actions)="row">
                <div class="btn-group" role="group">
                    <b-button variant="success" @click="approveItem(row.item.type, row.item.id)">Approve</b-button>
                    <b-button v-if="!showingRejectedItems" variant="outline" @click="rejectItem(row.item.type, row.item.id)">Reject</b-button>
                </div>
            </template>
        </b-table>

        <div v-else class="mt-3">
            <p v-if="showingRejectedItems">No rejected items found.</p>
            <p v-else><i class="bi bi-check-square mr-2"></i> All moderation is done, no pending items found.</p>
        </div>
    </div>
</template>

<script>
import { BButton, BTable } from 'bootstrap-vue';
import NotificationPop from "../mixins/NotificationPop";
import Loading from "./Loading";

export default {
    components: {
        BButton,
        BTable,
        Loading
    },
    mixins: [NotificationPop],
    data() {
        return {
            items: [],
            showingRejectedItems: false,
            loading: true,
            fields: [
                { key: 'type', label: 'Type' },
                { key: 'titleOrContent', label: 'Content' },
                { key: 'author', label: 'Author' },
                { key: 'actions', label: 'Actions', class: 'text-center' }
            ]
        };
    },
    methods: {
        fetchPendingItems() {
            this.loading = true;
            this.$http.get('/http_api/moderation/pending')
                .then(response => {
                    this.items = this.formatItems(response.data);
                    this.showingRejectedItems = false;
                    this.loading = false;
                })
                .catch(error => {
                    this.popNotification('Failed to fetch pending items.', 'danger');
                    console.error('Error fetching pending items:', error);
                });
        },
        fetchRejectedItems() {
            this.loading = true;
            this.$http.get('/http_api/moderation/rejected')
                .then(response => {
                    this.items = this.formatItems(response.data);
                    this.showingRejectedItems = true;
                    this.loading = false;
                })
                .catch(error => {
                    this.popNotification('Failed to fetch rejected items.', 'danger');
                    console.error('Error fetching rejected items:', error);
                });
        },
        formatItems(data) {
            const posts = data.posts.map(post => ({ ...post, type: 'post' }));
            const comments = data.comments.map(comment => ({ ...comment, type: 'comment' }));
            return [...posts, ...comments];
        },
        approveItem(type, id) {
            this.$http.post(`/http_api/moderation/approve/${type}/${id}`)
                .then(response => {
                    this.popNotification('Item approved successfully.', 'success');
                    // Remove the approved item from the list
                    this.items = this.items.filter(item => !(item.type === type && item.id === id));
                })
                .catch(error => {
                    this.popNotification('Failed to approve item.', 'danger');
                    console.error('Error approving item:', error);
                });
        },
        rejectItem(type, id) {
            this.$http.post(`/http_api/moderation/reject/${type}/${id}`)
                .then(response => {
                    this.popNotification('Item rejected successfully.', 'success');
                    // Remove the rejected item from the list
                    this.items = this.items.filter(item => !(item.type === type && item.id === id));
                })
                .catch(error => {
                    this.popNotification('Failed to reject item.', 'danger');
                    console.error('Error rejecting item:', error);
                });
        },
        popNotification(message, variant) {
            this.$bvToast.toast(message, {
                title: 'Notification',
                variant: variant,
                solid: true
            });
        }
    },
    mounted() {
        this.fetchPendingItems();
    }
};
</script>

<style scoped>
/* Add any custom styles here */
</style>
